/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { cloneDeep } from "lodash";

// apis
import { getCardPurchaseAllExcel, getCardsTypesPurchaseSummaries } from "../../../../apis/finances/cards";
// components
import Filters from "../../../../components/Filters";
// utils
import { getDay } from "../../../../utils/date";
import { getParams } from "../../../../utils/params";
import { isEmpty } from "../../../../utils/lodashExtend";
import useForm from "../../../../hooks/useForm";
import { transformComma } from "../../../../utils/validator/comma";
import ByPurchaseTable from "./ByPurchaseTable";
import NoData from "../../../../components/NoData/NoData";
import { HashLink as Link } from "react-router-hash-link";
import PageHeader from "../../../../components/PageHeader";
import { downExcelFile } from "../../../../utils/download";

import { getOnlyNumber } from "../../../../utils/number";
import { getFinancesAccounts } from "../../../../apis/finances/auth";

const ByPurchaseList = ({ activeTab, tabList, scrapingPermission, cardHistoryPermission }) => {
  const [tradeInfo, setTradeInfo] = useState({});
  // 스크래핑
  const [cardScrapings, setcardScrapings] = useState([]);

  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
    list, setList,
    total, setTotal,
    setValidateFields,
    erroes
  } = useForm(
    {
      search: {
        cardName: "",
        useStore: ""
      },
      range: {
        useDate: [getDay(7), getDay()]
      },
      page: 0,
      limit: 999
    },
  );

  useEffect(() => {
    if (!isEmpty(scrapingPermission) && scrapingPermission.level > 1) {
      const cardScrapings = [];
      Promise.all([getFinancesAccounts("card"), getFinancesAccounts("ccd")])
        .then((res) => {
          res.forEach(item => {
            (item?.data?.accounts || []).forEach(item => {
              cardScrapings.push(...item.financeScrapings);
            });
          });
          setcardScrapings(cardScrapings);
        });
    }

  }, [scrapingPermission]);

  useEffect(() => {
    //console.log(erroes)
  }, [erroes]);
  useEffect(() => {
    getCardsInfo(form);
    setSubmit(getCardsInfo);
    setValidateFields(filterConfig);
  }, []);

  const getCardsInfo = (params) => {

    const _params = cloneDeep(params);
    //console.log("_params", _params)
    params.useAmt = Number(getOnlyNumber(_params.useAmt));

    delete _params.useAmt;
    delete _params.search.useStore;

    getCardsTypesPurchaseSummaries(getParams(_params))
      .then((res) => {
        const { cardList, totalCount, totalTrCountSum, totalUseAmtSum, totalAddTaxSum } = res.data;
        setList(cardList);
        setTotal(totalCount);
        setTradeInfo({
          totalTrCountSum,
          totalUseAmtSum,
          totalAddTaxSum
        });
      });
  };

  const filterConfig = [
    {
      title: "조회기간",
      type: "customDatePicker",
      key: "range.useDate",
    },
    {
      title: "카드명 검색",
      key: "search.cardName",
      placeholder: '카드사 입력'
    },
    {
      title: "승인금액",
      type: "input",
      key: "useAmt",
      placeholder: '금액 입력',
      validators: ['comma', 'positive'],
    },
    {
      title: "가맹점",
      key: "search.useStore",
      placeholder: "가맹점명 입력",

    },
  ];

  const headerButtons = [
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const from = form.range.useDate[0];
        const to = form.range.useDate[1];

        const body = {
          range: {
            useDate: {
              from,
              to
            }
          },
          status: 'enabled'
        };
        getCardPurchaseAllExcel(body).then((res) => {
          downExcelFile(res, `신용카드 매입 건별 내역 ${from}~${to}.xlsx`);
        });
      },
      disabled: isEmpty(list)
    },
  ];

  return (
    <div className="by-purchase-list">
      <PageHeader
        title={"신용카드 내역"}
        activeTab={activeTab}
        tabList={tabList}
        buttons={headerButtons}
      />
      <Filters
        filters={filterConfig}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <div className="total-info-wrap">
        <span className="total-info-label used-card">사용된 카드<span className="count color-main-100">{total}</span></span>
        <span className="total-info-label trade-count">거래<span className="count color-main-100">{tradeInfo.totalTrCountSum || 0}</span></span>
        <span className="total-info-label use-amount">총 승인금액<span className="count amount">{transformComma(tradeInfo.totalUseAmtSum)}</span>원</span>
      </div>
      {!isEmpty(list) ?
        list.map((data, idx) => (
          <React.Fragment key={idx}>
            <ByPurchaseTable
              data={data}
              params={form}
              scrapingPermission={scrapingPermission}
              cardScrapings={cardScrapings}
              cardHistoryPermission={cardHistoryPermission}
            />
          </React.Fragment>
        )) :
        (
          <NoData text={
            <Link
              to="/manager/financial?tab=auto-scrapping#section-three"
              className="text-align-center"
              scroll={el => { el.scrollIntoView(true); window.scrollBy(0, 200); }}
            >
              <p className="color-gray-5 nowrap">
                {"관리자 > 금융 정보 자동 수집 > 신용카드 매입 정보를 연동해주세요."}
              </p>
              <p className="color-main-80 font-size-15">
                {"클릭시 해당 메뉴로 이동합니다."}
              </p>
            </Link>} />
        )}
    </div>
  );
};

export default ByPurchaseList;
